import request from "@/utils/request";

export function getProductionPage(data,pageNum,pageSize) {
    return request({
        url: `/order/findPage4Production`,
        method: 'post',
        params:{pageNum,pageSize},
        data
    })
}
